// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"09c9b474","293":"b39a5f95","787":"84abc9af"}[chunkId] + ".chunk.js";
};